import React from 'react';
import { useRole } from '../utils/RoleContext';

const RoleGuard = ({ allowedRoles, children }) => {
  const { role } = useRole();
  if (!role) return null;
  if (!allowedRoles.includes(role)) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You do not have permission to view this page.</p>
        <a href="/">Go to Home</a>
      </div>
    );
  }
  return <>{children}</>;
};

export default RoleGuard;
